import { motion } from 'framer-motion';

const sentence = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    transition: {
      delay: 0,
      staggerChildren: 0.04,
    },
  },
};

const letter = {
  hidden: {
    opacity: 0,
    y: 50,
  },
  visible: {
    opacity: 1,
    y: 0,
  },
};

export const AnimatedText = ({ text }: { text: string }): JSX.Element => (
  <motion.h3 variants={sentence} initial="hidden" animate="visible">
    {text.split('').map((char, index) => (
      <motion.span
        key={`${char}-${index}`}
        variants={letter}
        // BodyRegular className
        className="m-0 font-cera text-[16px] font-medium leading-[20px] tracking-[-0.22px] text-blue"
      >
        {char}
      </motion.span>
    ))}
  </motion.h3>
);
